import { createStructuredSelector } from "reselect";
import { getAccountSelectedTransactionInfo } from "../../../../../modules/Account/accountSelectors";
import { connect } from "react-redux";
import MobileHistoryTransactionIcon from "../MobileHistoryTransactionIcon";
import {
    MobileHistoryTransactionInfoAmountStyled,
    MobileHistoryTransactionInfoCompleteStyled,
    MobileHistoryTransactionInfoCopyContainerStyled
} from "./styled/MobileHistoryTransactionInfoStyled";
import { useLangContext } from "../../../../../providers/LangProvider/LangProviderContext";
import amountFormat from "../../../../../utils/amountFormat";
import classNames from "classnames";
import {
    STATE_TX,
    STATUS_TX,
    TRANSACTION_SIDES
} from "../../../../../modules/Account/components/TransactionHistory/transactionHistoryConstants";
import { BinIcon } from "../../../../../components/icon/Icon";
import { Button } from "react-bootstrap";
import { useCallback } from "react";
import MobileHistoryTransactionStatusInfo from "./MobileHistoryTransactionStatusInfo";
import { MobileHistoryInfoIconWrapperStyled } from "../../styled/MobileHistoryInfoStyled";
import MobileHistoryWithdrawalSteps from "./MobileHistoryWithdrawalSteps";

function MobileHistoryTransactionInfo(props) {
    const {selectedTransactionInfo} = props;
    const {getLangPath} = useLangContext();

    const handleCopyToClipboardTransactionID = useCallback(() => {
        navigator.clipboard.writeText(selectedTransactionInfo.uuid).then();
    }, [selectedTransactionInfo]);

    const handleCompleteTransaction = useCallback(() => {
        window.open(selectedTransactionInfo.payment_url);
    }, [selectedTransactionInfo]);

    const renderStatusInfo = useCallback(() => {
        if (selectedTransactionInfo.status === STATUS_TX.DEPOSIT_CREATED) {
            return <MobileHistoryTransactionStatusInfo
                description={getLangPath('lite_version.history.transaction.description.abandoned')}
                state={selectedTransactionInfo.state}
                title={getLangPath('lite_version.history.transaction.title.abandoned')}
            >
                <MobileHistoryTransactionInfoCompleteStyled>
                    {
                        !!selectedTransactionInfo.payment_url && (
                            <Button
                                onClick={handleCompleteTransaction}
                                variant="info"
                                size="md"
                                className="f16"
                            >
                                {getLangPath('transactions.complete')}
                            </Button>
                        )
                    }
                </MobileHistoryTransactionInfoCompleteStyled>
            </MobileHistoryTransactionStatusInfo>
        } else if ([STATUS_TX.PAYOUT_WAITING_DEALER, STATUS_TX.PAYOUT_WAITING_MANAGER].includes(selectedTransactionInfo.status)) {
            return <MobileHistoryWithdrawalSteps/>
        } else {
            return <MobileHistoryTransactionStatusInfo
                description={getLangPath(`transactions.state.${selectedTransactionInfo.state}.descr`)}
                state={selectedTransactionInfo.state}
                title={getLangPath(`transactions.state.${selectedTransactionInfo.state}.name`)}
            />
        }
    }, [getLangPath, handleCompleteTransaction, selectedTransactionInfo]);

    return <div className="d-flex flex-column align-items-center px-3">
        <MobileHistoryInfoIconWrapperStyled>
            <MobileHistoryTransactionIcon item={selectedTransactionInfo}/>
        </MobileHistoryInfoIconWrapperStyled>
        <h4 className="f16">
            {getLangPath(`lite_version.history.transaction.title.${selectedTransactionInfo.type}`,
                {payment_name: selectedTransactionInfo.payment_name})}
        </h4>
        <MobileHistoryTransactionInfoAmountStyled className={classNames({
            'positive': selectedTransactionInfo.state === STATE_TX.COMPLETED && selectedTransactionInfo.side === TRANSACTION_SIDES.UP,
        })}>
            {amountFormat(selectedTransactionInfo.amount, 2, '$')}
        </MobileHistoryTransactionInfoAmountStyled>
        {renderStatusInfo()}
        <MobileHistoryTransactionInfoCopyContainerStyled>
            <Button
                onClick={handleCopyToClipboardTransactionID}
                variant="info"
                size="md"
            >
                {getLangPath('transaction_history.copy_transaction_id')}
                <BinIcon name="IcDocCopy" style={{fontSize: '16px', marginLeft: '6px'}}/>
            </Button>
        </MobileHistoryTransactionInfoCopyContainerStyled>
    </div>
}

const mapStateToProps = createStructuredSelector({
    selectedTransactionInfo: getAccountSelectedTransactionInfo,
});

export default connect(mapStateToProps)(MobileHistoryTransactionInfo);
